import PropTypes from 'prop-types';
import useTiltifyConfig from '@hooks/useTiltifyConfig.js';

TiltifyPollSelector.propTypes = {
  onPollSelected: PropTypes.func,
  disabled: PropTypes.bool,
  polls: PropTypes.array,
  pollsLoading: PropTypes.bool,
};

export default function TiltifyPollSelector({
  onPollSelected,
  disabled = false,
  polls,
  pollsLoading,
}) {
  const config = useTiltifyConfig();

  const setSelectedPoll = (e) => {
    const pollID = e.target.value;
    const goal = polls.find((poll) => poll.id === pollID).goal;
    config.tiltifyPollID = pollID === null ? null : pollID;
    config.tiltifyCampaignGoal = goal;

    localStorage.setItem('tiltifyPollID', pollID);
    onPollSelected({ id: pollID, goal });
  };

  const pollOptions = polls.map((poll) => {
    return (
      <option title={poll.name} value={poll.id} key={poll.id} id={poll.id}>
        {poll.name}
      </option>
    );
  });

  if (pollsLoading)
    return (
      <label className="form-control w-full">
        <div className="label">
          <span className="label-text">Poll</span>
        </div>
        <div className="select skeleton" />
        <div className="label">
          <span className="label-text-alt">Loading polls...</span>
        </div>
      </label>
    );

  return (
    <label className="form-control w-full">
      <div className="label">
        <span className="label-text">Poll</span>
      </div>
      <select
        className="select select-bordered w-full"
        onChange={setSelectedPoll}
        disabled={disabled}
        value={
          config.tiltifyPollID && config.tiltifyPollID.length
            ? config.tiltifyPollID
            : null
        }
      >
        <option
          title="Please select a poll"
          value="null"
          disabled
          selected={!config.tiltifyPollID || config.tiltifyPollID.length === 0}
        >
          Please select a poll
        </option>

        {pollOptions}
      </select>
    </label>
  );
}
